export enum LoyanltyAction {
  GET_BRAND_LOYALTY = "getBrandLoyalty",
  GET_USER_LOYALTY = "getUserLoyalty",
  UPDATE_LOYALTY = "updateLoyalty",
  SET_BRAND_LOYALTY = "setBrandLoyalty",
  SET_USER_LOYALTY = "setUserLoyalty",
}
